var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocketSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9fdbf3;}.cls-2{fill:#b2e5fb;}.cls-3{fill:#dad7e5;}.cls-4{fill:#edebf2;}.cls-5{fill:#c6c3d8;}.cls-6{fill:#db5669;}.cls-7{fill:#f26674;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rocket Startup") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rocket_Startup",
    "data-name": "rocket Startup"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47,7V31H1V7A4,4,0,0,1,4.52,3C4.89,3,2.37,3,43,3A4,4,0,0,1,47,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47,7V29H28A24,24,0,0,1,4,5a4.09,4.09,0,0,1,.35-1.64L5,3H43A4,4,0,0,1,47,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47,31c0,1.9.13,2.83-.52,4A4,4,0,0,1,43,37H5a4,4,0,0,1-4-4V31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M47,31c0,1.9.13,2.83-.52,4C46.11,35,48.63,35,8,35a4,4,0,0,1-4-4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 18,
    y: 37,
    width: 12,
    height: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30,39v8H20a8,8,0,0,1,8-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M28.53,17c-.46,3.53-.34,2.67-.53,4H20c-.32-2.4-.2-1.48-.53-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M28.53,17l-.39,3H23a2.32,2.32,0,0,1-2.29-2l-.13-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M29.08,11.39A30.78,30.78,0,0,1,28.53,17H19.47a33.57,33.57,0,0,1-.55-5.61A14.18,14.18,0,0,1,24,1l0,0A14.17,14.17,0,0,1,29.08,11.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.08,11.39A19.08,19.08,0,0,1,28.8,15h-4A3.76,3.76,0,0,1,21,11.74,14.26,14.26,0,0,1,24,1,14.17,14.17,0,0,1,29.08,11.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M35,19H28.27c.63-4.84.88-5.91.81-7.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M34.22,18H31.29a1.77,1.77,0,0,1-1.76-2s0,.26.44-3.26C30,12.5,29.33,11.72,34.22,18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M19.73,19H13l5.92-7.61C18.85,13.11,19.06,13.88,19.73,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M16.71,18H13.78L18,12.56s.45,3.39.46,3.44A1.78,1.78,0,0,1,16.71,18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 24,
    cy: 11,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M41,31H7a4,4,0,0,1,4-4h4a3,3,0,0,1,.88-2.12c1.52-1.52,2.72-.24,4.24-1.76A3,3,0,0,0,21,21h6a3,3,0,0,0,3,3,3,3,0,0,1,3,3h4A4,4,0,0,1,41,31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.71,29a1.33,1.33,0,0,1-1.19-1.94A4,4,0,0,0,7,31H41a4,4,0,0,0-.55-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,2H26.43A15.76,15.76,0,0,0,24.64.23a1.06,1.06,0,0,0-1.28,0A15.76,15.76,0,0,0,21.57,2H5A5,5,0,0,0,0,7V33a5,5,0,0,0,5,5H17v8H15a1,1,0,0,0,0,2H33a1,1,0,0,0,0-2H31V38H43a5,5,0,0,0,5-5V7A5,5,0,0,0,43,2Zm0,2a3,3,0,0,1,3,3V30H41.9A5,5,0,0,0,37,26H33.87A4,4,0,0,0,30,23,2,2,0,0,1,28.25,22a1,1,0,0,0,.74-.82L29.14,20H35a1,1,0,0,0,.79-1.61c-5.86-7.69-5.63-7.4-5.73-7.5A15,15,0,0,0,27.89,4ZM24,2.37a13.06,13.06,0,0,1,4,11.24L27.66,16H20.34L20,13.61A13.06,13.06,0,0,1,24,2.37ZM20.88,20l-.27-2h6.78l-.27,2Zm9.06-6,3,4H29.41ZM18.06,14l.53,4H15Zm3.8,8h4.28A4,4,0,0,0,30,25a2,2,0,0,1,2,2,1,1,0,0,0,1,1h4a3,3,0,0,1,2.82,2H8.18A3,3,0,0,1,11,28h4a1,1,0,0,0,1-1,2,2,0,0,1,2-2A4,4,0,0,0,21.86,22ZM2,7A3,3,0,0,1,5,4H20.11c-2.22,3.64-2,6.6-2.31,7.06-6,7.91-6.07,7.62-5.7,8.38s.48.56,6.76.56c.15,1.11.1,1.74.89,1.95A2,2,0,0,1,18,23a4,4,0,0,0-3.87,3H11a5,5,0,0,0-4.9,4H2ZM29,46H19V38H29ZM46,33a3,3,0,0,1-3,3H5a3,3,0,0,1-3-3V32H46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,33a1,1,0,0,0,0,2A1,1,0,0,0,8,33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,14a3,3,0,1,0-3-3A3,3,0,0,0,24,14Zm0-4a1,1,0,0,1,0,2A1,1,0,0,1,24,10Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketSvg);
export default __webpack_public_path__ + "static/media/rocket-svg.aae714dbc5f93cec032d6a0d544aae04.svg";
export { ForwardRef as ReactComponent };